import React from 'react';
import OptionList from './OptionList';
import { AsButton } from '@adserve/adserve-react-components';

const panel = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: 132,
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    backgroundColor: '#FFFFFF',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
    marginTop: 5,
    paddingBottom: 20,
    position: 'absolute',
    zIndex: 210
};

const buttonStyle = {
    height: 34,
    width: 96,
    fontSize: 15,
    fontWeight: 500
};

const SelectPanel = ({ id, options, visible = false, selectedOption, onOptionChange, onClickCreateButton, actionText = 'Create' }) => {
    return (
        visible && (
            <div style={panel}>
                <div style={{ height: 35 }} />
                <div>
                    <OptionList
                        options={options}
                        selectedOption={selectedOption}
                        spaceBetween={20}
                        onOptionChange={onOptionChange}
                    />
                </div>
                <div style={{ height: '10%', marginTop: 20 }} />
                <AsButton
                    id={id + '-create-btn'}
                    style={buttonStyle}
                    handleClick={onClickCreateButton}
                >{actionText}</AsButton>
            </div>
        )
    );
};

export default SelectPanel;
